var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymptoms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.006 34.963-3.423-8.233a7.8 7.8 0 0 1 -.62-2.529c-.663-12.023-10.385-21.768-22.125-22.186a23 23 0 0 0 -16.747 39.6 2.989 2.989 0 0 1 .909 2.142v18.243h24v-7h2.192a4.99 4.99 0 0 0 4.161-2.227l2.447-3.664a2 2 0 0 0 -1.668-3.109h-3.651l-2.4-3h9.919v-4h4.193a3 3 0 0 0 2.813-4.037zm-2 1.618a.992.992 0 0 1 -.815.419h-4.191a2 2 0 0 0 -2 2v2h-7.919a2 2 0 0 0 -1.562 3.25l2.4 3a1.988 1.988 0 0 0 1.561.75h3.652l-2.444 3.665a3 3 0 0 1 -2.496 1.335h-2.192a2 2 0 0 0 -2 2v5h-20v-16.244a5 5 0 0 0 -1.524-3.584 21.006 21.006 0 0 1 -.057-30.285 20.782 20.782 0 0 1 15.349-5.873c10.715.381 19.588 9.3 20.2 20.3a9.745 9.745 0 0 0 .769 3.186l3.4 8.175a.994.994 0 0 1 -.129.906z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m49 42h2v2h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49 46h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m53 44h2v2h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m46 44h2v2h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m57 44h5v2h-5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m52.062 40.5h1.999v1.999h-1.999z",
    transform: "matrix(.866 -.5 .5 .866 -13.642 32.101)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m55.325 37.75h5v2h-5z",
    transform: "matrix(.866 -.5 .5 .866 -11.627 34.098)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m52.062 47.5h1.999v1.999h-1.999z",
    transform: "matrix(.5 -.866 .866 .5 -15.475 70.193)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m56.825 48.75h2v5h-2z",
    transform: "matrix(.5 -.866 .866 .5 -15.471 75.703)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptoms);
export default __webpack_public_path__ + "static/media/Symptoms.3ad5ca1d.svg";
export { ForwardRef as ReactComponent };